import React, { useState, useEffect } from 'react';
import { ref, set, get, child } from 'firebase/database';
import { database } from '../firebase';

const CreatePartnership = () => {
  const [folderCount, setFolderCount] = useState(0);
  const [category, setCategory] = useState('');
  const [serverLink, setServerLink] = useState('');
  const [partnershipName, setPartnershipName] = useState('');
  const [ImageLink, setImageLink] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Fetch the current folder count from Firebase on component mount
    const dbRef = ref(database, 'partnerships');
    get(child(dbRef, 'folderCount')).then((snapshot) => {
      if (snapshot.exists()) {
        setFolderCount(snapshot.val());
      }
    }).catch((error) => {
      console.error(error);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (category.trim() === '' || serverLink.trim() === '' || partnershipName.trim() === '' || ImageLink.trim() === '') {
      setMessage('All fields are required');
      return;
    }

    const nextFolderName = `partnership${String(folderCount + 1).padStart(3, '0')}`;
    const folderRef = ref(database, `partnerships/${nextFolderName}`);

    set(folderRef, {
      category,
      serverLink,
      partnershipName,
      ImageLink,
      createdAt: new Date().toISOString(),
    }).then(() => {
      // Update the folder count
      set(ref(database, 'partnerships/folderCount'), folderCount + 1);
      setMessage('Folder created successfully');
      setCategory('');
      setServerLink('');
      setPartnershipName('');
      setImageLink('');
      setFolderCount(folderCount + 1);
    }).catch((error) => {
      setMessage(`Error: ${error.message}`);
    });
  };

  return (
    <div className="pnm-create-partnership-wrapper">
      <form className="pnm-form" onSubmit={handleSubmit}>
        <label className="pnm-label" htmlFor="category">
          Category:
        </label>
        <input
          className="pnm-input"
          type="text"
          id="category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        
        <label className="pnm-label" htmlFor="serverLink">
          Server Link:
        </label>
        <input
          className="pnm-input"
          type="text"
          id="serverLink"
          value={serverLink}
          onChange={(e) => setServerLink(e.target.value)}
        />

        <label className="pnm-label" htmlFor="partnershipName">
          Partnership Name:
        </label>
        <input
          className="pnm-input"
          type="text"
          id="partnershipName"
          value={partnershipName}
          onChange={(e) => setPartnershipName(e.target.value)}
        />

        <label className="pnm-label" htmlFor="ImageLink">
        Image Link:
        </label>
        <input
          className="pnm-input"
          type="text"
          id="ImageLink"
          value={ImageLink}
          onChange={(e) => setImageLink(e.target.value)}
        />
        
        <button className="pnm-button" type="submit">
          Create Partnership
        </button>
      </form>
      {message && <p className="pnm-message">{message}</p>}
    </div>
  );
};

export default CreatePartnership;
